import React, { useState } from "react";
import "./module.style.scss";
import BulletPont from "./BulletPont";

const Stepper = ({currentStep, numberOfSteps, steps , handleStepClick = () => {}}) => {

  return (
    <div className="stepper mb-2">
      {Array.from({ length: numberOfSteps }).map((_, index) => (
        <div
          key={index}
          className={`step ${index === currentStep ? "active" : ""}`}
          onClick={() => handleStepClick(index)}
        >
          <div className="step-text flex">
            <BulletPont currentStep = {currentStep} isActive={index === currentStep} step={index + 1} />
            {steps[index]}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Stepper;
